export default "/assets/images/milacares.jpg?0b7fa3cec89876ab2658a13b46454f1c";